var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 124,
    viewBox: "0 0 248 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H224C237.255 0 248 10.7452 248 24V100C248 113.255 237.255 124 224 124H24C10.7452 124 0 113.255 0 100V24Z",
    fill: "#7C5AC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.3407 31.15C91.3708 30.8901 90.3738 31.4657 90.1139 32.4357L79.7611 71.0727C79.5012 72.0426 80.0768 73.0396 81.0468 73.2995L151.296 92.1227C152.266 92.3826 153.263 91.807 153.523 90.8371L163.876 52.2C164.135 51.2301 163.56 50.2331 162.59 49.9732L92.3407 31.15ZM135.868 65.4009C133.789 73.1604 125.813 77.7653 118.054 75.6861C110.294 73.607 105.689 65.6312 107.768 57.8717C109.848 50.1121 117.823 45.5073 125.583 47.5865C133.342 49.6656 137.947 57.6414 135.868 65.4009Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4544 39.8182C84.4503 39.8182 83.6362 40.6323 83.6362 41.6364V81.6364C83.6362 82.6406 84.4503 83.4546 85.4544 83.4546H158.182C159.186 83.4546 160 82.6406 160 81.6364V41.6364C160 40.6323 159.186 39.8182 158.182 39.8182H85.4544ZM136.364 61.6364C136.364 69.6697 129.851 76.1819 121.818 76.1819C113.785 76.1819 107.273 69.6697 107.273 61.6364C107.273 53.6032 113.785 47.091 121.818 47.091C129.851 47.091 136.364 53.6032 136.364 61.6364ZM121.818 68.9091C125.835 68.9091 129.091 65.653 129.091 61.6364C129.091 57.6198 125.835 54.3637 121.818 54.3637C117.801 54.3637 114.545 57.6198 114.545 61.6364C114.545 65.653 117.801 68.9091 121.818 68.9091Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartSmall);
export default __webpack_public_path__ + "static/media/start-small.9d885b56.svg";
export { ForwardRef as ReactComponent };